import type { PageContent } from '../schema';

export const weddingGiftingPageContent = {
  id: 'wedding-gifting',
  title: 'Wedding Gifting',
  description: 'Curated silk sarees, dhotis, and personalized gifting experiences for Tamil wedding traditions.',
  sections: [
    {
      id: 'gifting-options',
      title: 'Curated Gifting Experiences',
      description: 'Saree bundles, dhoti collections, and keepsake notes for every ritual.',
    },
    {
      id: 'faq',
      title: 'Your Questions, Answered',
      description: 'Wedding gifting FAQs can be added here when authored.',
    },
  ],
} satisfies PageContent;
